
<fieldset class="q-fieldset my-1">
  <legend><i class="fas fa-file-alt"></i>{{GetTitle()}}</legend>

  <div class="doc-container">

    <div class="d-flex flex-wrap justify-content-between align-items-center " *ngFor="let doc of ListDoc">
      <div class="d-flex align-items-center mt-3" *ngIf="doc.ListElementLinked && doc.ListElementLinked.length > 0">

        <div class="q-check">
          <input type="checkbox" id="{{doc.Ident}}" [(ngModel)]="doc.IsSelected" (change)="EmitDoc(doc)" />
          <label for="{{doc.Ident}}">
            <span></span>
          </label>

        </div>
        {{doc.Title}}
        <div *ngIf="doc.ListElementLinked.length < 6" class="d-flex">
          <div *ngFor="let element of doc.ListElementLinked" class="mx-1"
               [title]="element.Text">
            <img src="{{element.Img}}" onerror="this.onerror=null; this.src='assets/images/Profil.png'" loading="lazy" class="ImgUser">
          </div>
        </div>
        <div *ngIf="doc.ListElementLinked.length > 5">
          <div class="selected-element-container ml-2" [title]="GetListElement(doc.ListElementLinked)">
            <i class="fas fa-user-plus fa-flip-horizontal"></i>
            <div class="number-circle">
              {{doc.ListElementLinked.length}}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


</fieldset>
